<div class="ap-px-spacing-6 position-relative">
  <h2 class="mb-3">{{ 'taxResult.title' | translate }}</h2>
  <gstar-cards-grid
    #grid
    [headers]="headers()"
    [source]="securities().items"
    [totalRows]="securities().total"
    (queryChange)="queryChangedHandler($event)">
    <div start-toolbar>
      <gstar-tax-result-status-dropdown
        gstarDropDownAppkitOverlayListFix
        (selectItem)="onSelectFilterItem($event)" />
    </div>
    <div
      class="d-flex align-items-center justify-content-end gap-3 flex-wrap mb-3"
      end-toolbar>
      <div class="d-flex align-items-center gap-2 tax-result-select-all pt-4">
        <ap-checkbox
          #selectAllCheckbox
          [disabled]="securities().items.length === 0"
          (onChange)="onSelectAllCheckboxChange($event)" />
        <span>{{ 'taxResult.selectAll' | translate }}</span>
      </div>
      <span class="pt-4">
        {{
          'taxResult.counterSecurities'
            | translate: { counter: selectedCount() }
        }}
      </span>
      <ap-button
        class="mt-4 px-2"
        btnType="primary"
        [label]="'portfolio.actionMenu.view' | translate"
        [disabled]="selectedCount() === 0"
        (onClick)="goToViewTaxResults()" />
      <ap-button
        class="mt-4"
        btnType="primary"
        [label]="'portfolio.actionMenu.edit' | translate"
        [disabled]="selectedCount() === 0"
        (onClick)="editTaxResult()" />
    </div>
    <ng-template #cardTemplate let-row>
      <gstar-tax-card
        class="col-12 col-md-6 col-lg-4 p-3"
        [security]="row"
        (selection)="onSecuritySelected($event)" />
    </ng-template>
  </gstar-cards-grid>
</div>
